module.exports = __webpack_public_path__ + "img/edge_activites_baignade.f2ea2bdf.svg";